import { useIgnoreEffectDeps } from '@common/hooks';

export const useResetEntryCount = (editModalVisible: boolean, resetCountHandler: (count: number) => void) => {
  useIgnoreEffectDeps(() => {
    if (!editModalVisible) {
      resetCountHandler(0);
    }
  }, [editModalVisible]);
};
